/** Englische Fassungen für den Bereich „review" (Schlüssel = deutscher Satz). */
export const EN_REVIEW: Record<string, string> = {
  'Erfasste Plattformkosten': 'Recorded platform costs',
  'Gemeinsame Laufplanung und Kosten eigener Anbieter-Keys sind hier nicht enthalten.': 'Shared run planning and charges on your own provider keys are not included here.',
  'Bitte prüfen': 'Please review',
  'Noch nicht geprüft': 'Not yet checked',
  'Der Agent baut gerade 1 Beitrag nach dem Rezept „{recipe}".': 'The agent is building 1 post with the recipe "{recipe}".',
  'Der Agent baut gerade 1 Beitrag.': 'The agent is building 1 post.',
  'Für TikTok-Fotos muss die öffentliche Medien-Domain bei TikTok verifiziert sein. Wähle TikTok Video oder richte die Domain ein.': 'For TikTok photos, the public media domain must be verified with TikTok. Choose TikTok Video or set up the domain.',
  'TikTok-Fotos können noch nicht übertragen werden: Die öffentliche Medien-Domain ist bei TikTok nicht verifiziert. Wähle TikTok Video oder richte die Domain ein.': 'TikTok photos cannot be transferred yet: the public media domain is not verified with TikTok. Choose TikTok Video or set up the domain.',
  'Bei TikTok landet der Beitrag als Entwurf in deiner TikTok-Inbox, solange Direct Post nicht freigeschaltet ist. Öffne dort die Benachrichtigung und poste ihn fertig. Den Stand und eventuelle Fehler siehst du unter Veröffentlichen.': 'On TikTok the post lands as a draft in your TikTok inbox until Direct Post is enabled. Open the notification there and finish posting. You can follow the status and any errors under Publish.',
  'Verwendetes Rezept': 'Recipe used',
  'Rezept nicht mehr vorhanden': 'Recipe no longer available',
  'Dieses Rezept bestimmt Format, Bildstil und Modell.': 'This recipe determines format, image style and model.',
  'Bildmodell automatisch': 'Automatic image model',
  'Rezept ansehen': 'View recipe',
  // Prüfen
  'Freigegeben · geht {when} raus': 'Approved · goes out {when}',
  'Verworfen · der Agent baut Ersatz': 'Discarded · the agent builds a replacement',
  'Fehlende Bilder werden neu gebaut.': 'Rebuilding the missing images.',
  '{n} Entwürfe warten auf dein OK. Freigegebene Beiträge gehen zum geplanten Zeitpunkt raus.': '{n} drafts are waiting for your OK. Approved posts go out at their scheduled time.',
  'Hier landet jeder Entwurf, bevor er veröffentlicht wird.': 'Every draft lands here before it is published.',
  'Sieh dir jeden Entwurf an und gib ihn frei. Freigeben rendert den Beitrag und plant ihn ein; Verwerfen nimmt ihn aus der Warteschlange.': 'Look at each draft and approve it. Approving renders the post and schedules it; discarding takes it out of the queue.',
  'Deine Beiträge sind eingeplant. Der Agent legt nach, sobald die Warteschlange leer läuft.': 'Your posts are scheduled. The agent adds more as soon as the queue runs low.',
  'Zum Kalender': 'Go to calendar',
  'Offene Entwürfe': 'Open drafts',
  '{n} offen · in Reihenfolge der Veröffentlichung': '{n} open · in publishing order',
  'Ohne Hook': 'No hook',
  'Bildserie · {n} Bilder zum Wischen': 'Photo series · {n} images to swipe',
  'Video · {n} Clips · MP4 9:16': 'Video · {n} clips · MP4 9:16',
  'Hook': 'Hook',
  'Alle Details': 'All details',
  'Zeitpunkt': 'Time',
  'Rezept': 'Recipe',
  'Serie': 'Series',
  'Teil {a} von {b} · {title}': 'Part {a} of {b} · {title}',
  'Dem Beitrag fehlt ein Termin.': 'This post has no scheduled time.',
  'Freigeben · {when}': 'Approve · {when}',
  'freigeben': 'approve',
  'bearbeiten': 'edit',
  'oder': 'or',
  'vorheriger / nächster Entwurf': 'previous / next draft',
  'Der Entwurf verschwindet aus der Warteschlange und wird nicht veröffentlicht.': 'The draft leaves the queue and will not be published.',
  'Alles geprüft': 'All reviewed',
  'Video + Bildserie': 'Video + photo series',
  'Bildserie · {n} Bilder': 'Photo series · {n} images',
  'Video · {n} Szenen': 'Video · {n} scenes',
  'Der Beitrag hat noch keine Szene.': 'This post has no scene yet.',
  '{n} von {m} Szenen ohne Bild. Neu bauen zieht sie nach, oder du ersetzt sie im Builder.': '{n} of {m} scenes have no image. Rebuild fills them in, or replace them in the builder.',
  'Kein Kanal gewählt. Lege im Builder fest, wohin der Beitrag geht.': 'No channel selected. Choose in the builder where the post goes.',
  'Kein Termin gesetzt. Ohne Termin lässt sich nicht freigeben.': 'No time set. Without one, the post cannot be approved.',
  '{channel}: braucht mindestens ein Bild.': '{channel}: needs at least one image.',
  '{channel}: {n} Bilder, erlaubt sind höchstens {max}.': '{channel}: {n} images, at most {max} are allowed.',
  '{channel}: {n} von max. {max} Bildern, Instagram bekommt 4:5-Zuschnitte': '{channel}: {n} of max. {max} images, Instagram gets 4:5 crops',
  '{channel}: {n} von max. {max} Bildern': '{channel}: {n} of max. {max} images',
  'Reels brauchen mindestens {n} Sekunden': 'Reels need at least {n} seconds',
  'Reels dürfen höchstens {n} Sekunden lang sein': 'Reels can be at most {n} seconds long',
  'Stories dürfen höchstens {n} Sekunden lang sein': 'Stories can be at most {n} seconds long',
  'Hochformat 9:16, {n} Szenen, {s} Sekunden': 'Portrait 9:16, {n} scenes, {s} seconds',
  'Musik „{name}" aus deiner Bibliothek, Lizenz: {license}': 'Music "{name}" from your library, license: {license}',
  'Musik „{name}" aus deiner Bibliothek': 'Music "{name}" from your library',
  'Ohne Musik, keine Lizenzfrage': 'No music, no licensing question',
  'Hashtags: {n}, Instagram erlaubt höchstens {max}': 'Hashtags: {n}, Instagram allows at most {max}',
  'Hashtags: {n} von max. {max}': 'Hashtags: {n} of max. {max}',
  'Hashtags: {n}': 'Hashtags: {n}',
  'Caption mit Hashtags hat {n} Zeichen, Instagram erlaubt {max}.': 'Caption with hashtags has {n} characters, Instagram allows {max}.',

  // Sammelansicht
  'Hier sammeln sich die Entwürfe aller Projekte. In Ruhe prüfen, mit Vorschau und Checks, kannst du im Projekt unter „Prüfen".': 'Drafts from all projects gather here. To review them properly, with preview and checks, open "Review" in the project.',
  'Prüfen →': 'Review →',

  // Lauf live
  'Der letzte Lauf hat noch {n} offene Beiträge. Ein neuer Lauf plant von vorn und kostet erneut. Trotzdem neu starten?': 'The last run still has {n} open posts. A new run plans from scratch and costs again. Start anyway?',
  'Lauf #{n} · live': 'Run #{n} · live',
  'Lauf · live': 'Run · live',
  'Lauf #{n}': 'Run #{n}',
  'Hier siehst du live, wie der Agent Beiträge baut.': 'Watch the agent build posts here, live.',
  'Der Agent baut gerade {n} Beiträge nach dem Rezept „{recipe}".': 'The agent is building {n} posts with the recipe "{recipe}".',
  'Der Agent baut gerade {n} Beiträge.': 'The agent is building {n} posts.',
  'Rezept „{recipe}"': 'Recipe "{recipe}"',
  'Schreibt die Texte, Beitrag {a} von {b}': 'Writing the texts, post {a} of {b}',
  'Baut gerade Beitrag {a} von {b}': 'Building post {a} of {b}',
  'Der Agent entwirft gerade die Hooks und Themen. Gleich erscheinen die Beiträge hier.': 'The agent is drafting hooks and topics. The posts will appear here shortly.',
  '{a} von {b} Beiträgen noch offen. „Weitermachen" holt sie nach, ohne neu zu planen.': '{a} of {b} posts still open. "Continue" finishes them without planning again.',
  'Die Automatik ist aus, Läufe startest du selbst.': 'Automation is off, you start runs yourself.',
  'Alle Rezepte': 'All recipes',
  '{n} Läufe arbeiten gerade:': '{n} runs are working right now:',
  'Starte einen Lauf, oder schalte die Automatik ein, damit der Agent selbstständig nachlegt, sobald die Warteschlange leer läuft.': 'Start a run, or turn on automation so the agent adds posts on its own when the queue runs low.',
  'Ablauf': 'Progress',
  'Entwürfe prüfen →': 'Review drafts →',
  'Zum Kalender →': 'Go to calendar →',
  'Ideen-Vorrat': 'Idea backlog',
  'daraus baut der Agent als Nächstes': 'the agent builds from these next',
  'Entsteht gerade': 'In progress',
  'Beiträge dieses Laufs': 'Posts in this run',
  '{n} fehlgeschlagen': '{n} failed',
  'plant…': 'planning…',
  'Beitrag {a} von {b}': 'Post {a} of {b}',
  'nur dieses Rezepts': 'this recipe only',
  'dieses Rezept nutzt keine Musik': 'this recipe uses no music',
  'fester Titel aus dem Rezept': 'fixed track from the recipe',
  'passend zur Stimmung des Beitrags': 'matching the mood of the post',
  'Kosten reserviert': 'Costs reserved',
  '{n} Credits geblockt': '{n} credits held',
  'Credits werden geblockt': 'Holding credits',
  'Plan erstellt': 'Plan created',
  '{n} Hooks, Captions & Hashtags': '{n} hooks, captions & hashtags',
  'Hooks, Captions & Hashtags': 'Hooks, captions & hashtags',
  'Medien generieren': 'Generating media',
  '{a}/{b} Beiträge bebildert mit {model}': '{a}/{b} posts illustrated with {model}',
  '{a}/{b} Beiträge bebildert': '{a}/{b} posts illustrated',
  'Musik auswählen': 'Choosing music',
  'Entwürfe ablegen': 'Saving drafts',
  'erscheinen danach unter Prüfen': 'they then appear under Review',
  'hier abgebrochen, siehe Fehler oben': 'stopped here, see the error above',
  'abgebrochen': 'aborted',
  'Dieser Beitrag ist nicht fertig geworden.': 'This post did not finish.',
  'Wird neu gebaut…': 'Rebuilding…',
  'Szene {n} ✓': 'Scene {n} ✓',
  'generiert…': 'generating…',
  'fehlt': 'missing',
  'von {n} reserviert': 'of {n} reserved',
  'Nicht verbrauchte Credits gehen automatisch zurück.': 'Unused credits are returned automatically.',
  'Protokoll': 'Log',
  'Ganzes Protokoll ({n} Zeilen)': 'Full log ({n} lines)',
  'Text neu gesetzt · {n} Bilder': 'Text repositioned · {n} images',
  'Kein Bild mit Text gefunden.': 'No image with text found.',
  'App-Folie angehängt · sieh sie dir als letzte Folie an': 'App slide added · check it as the last slide',
  'Setzt die Texte an eine freie Stelle im Bild, nie über Gesichter. Kein Bild wird neu erzeugt.': 'Moves the text to a free spot in the image, never over faces. No image is regenerated.',
  'Text neu setzen': 'Reposition text',
  'Hängt eine letzte Folie an: Ein Handy liegt beiläufig im Bild, deine App ist offen. Dazu eine Zeile, die die App nennt.': 'Adds a final slide: a phone lying casually in the shot with your app open, plus a line naming the app.',
  'App-Folie anhängen': 'Add app slide',
  'Wird gerendert, geprüft und dann veröffentlicht. TikTok ist zurückgestellt, bis die Medien-Domain verifiziert ist; dort die Bilder selbst posten. Findet die Prüfung etwas, liegt der Beitrag mit dem Befund wieder hier.': 'Being rendered, checked and then published. TikTok is held back until the media domain is verified; post the images there yourself. If the check finds something, the post comes back here with the finding.',
  'Wird gerendert, geprüft und dann veröffentlicht. Findet die Prüfung etwas, liegt der Beitrag mit dem Befund wieder hier.': 'Being rendered, checked and then published. If the check finds something, the post comes back here with the finding.',
  'Veröffentlichen fehlgeschlagen': 'Publishing failed',
  'Verbinde zuerst TikTok, Instagram oder Facebook.': 'Connect TikTok, Instagram or Facebook first.',
  'Posten geht mit verbundenem Kanal': 'Posting needs a connected channel',
  'Jetzt posten': 'Post now',
  'Geht zum angezeigten Termin raus.': 'Goes out at the time shown.',
  'Einplanen · nächster freier Termin': 'Schedule · next free slot',
  'Einplanen · {when}': 'Schedule · {when}',
  'Einplanen': 'Schedule',
  'TikTok kann die Bilder noch nicht abholen, weil die Medien-Domain bei TikTok nicht verifiziert ist. Beim Posten wird TikTok deshalb zurückgestellt; poste die Bilder dort selbst mit Musik aus dem Katalog („Selbst posten“). Instagram bekommt die Bilder zum Wischen.': 'TikTok cannot fetch the images yet because the media domain is not verified with TikTok. TikTok is therefore held back when posting; post the images there yourself with music from the catalogue (“Post yourself”). Instagram gets the swipeable images.',
  'Jetzt veröffentlichen?': 'Publish now?',
  'Der Beitrag geht sofort an {targets}. Das lässt sich auf der Plattform nur von Hand wieder löschen.': 'The post goes out right away to {targets}. It can only be removed by hand on the platform.',
  'deine Kanäle': 'your channels',
  'Ja, jetzt posten': 'Yes, post now',
  'Textart': 'Text style',
  'Zeile': 'Line',
  'Chat-Blase': 'Chat bubble',
  'Mitteilung': 'Notification',
  'Schlagzeile': 'Headline',
  'Notiz': 'Note',
  'Absender, z. B. Lena': 'Sender, e.g. Lena',
  'App oder Absender': 'App or sender',
  '„Ich" = eigene Nachricht, blau rechts': '"Ich" = your own message, blue on the right',
  'Steht fett oben in der Karte': 'Shown in bold at the top of the card',
  'Zahl-Karte': 'Number card',
  'Liste': 'List',
  'Vergleich': 'Comparison',
  'Balken': 'Bar',
  'Was die Zahl bedeutet': 'What the number means',
  'Titel der Liste': 'List title',
  'Überschriften, z. B. Ohne | Mit': 'Headings, e.g. Without | With',
  'Beschriftung, z. B. Aufwand': 'Label, e.g. Effort',
  'Zeile = nur der Wert, z. B. 73 %': 'Line = just the value, e.g. 73 %',
  'Zeile = Punkte, mit „ / " getrennt': 'Line = points separated by " / "',
  'Zeile = links | rechts': 'Line = left | right',
  'Zeile = Wert, z. B. 8/10 oder 80 %': 'Line = value, e.g. 8/10 or 80 %',
  'Schritt': 'Step',
  'Checkliste': 'Checklist',
  'Mythos/Fakt': 'Myth/fact',
  'Ranking': 'Ranking',
  'Umfrage': 'Poll',
  'Quiz': 'Quiz',
  'Zeitleiste': 'Timeline',
  'Zitat': 'Quote',
  'Wisch-Hinweis': 'Swipe hint',
  'Sticker': 'Sticker',
  'Schritt, z. B. 2/4': 'Step, e.g. 2/4',
  'Titel des Rankings': 'Ranking title',
  'Die Frage': 'The question',
  'Titel': 'Title',
  'Quelle': 'Source',
  'Zeile = der Schritt': 'Line = the step',
  'Zeile = Platz 1 / Platz 2 / Platz 3': 'Line = rank 1 / rank 2 / rank 3',
  'Zeile = Option A | Option B': 'Line = option A | option B',
  'Zeile = Antworten, mit „ / " getrennt': 'Line = answers separated by " / "',
  'Zeile = 07:30 Text / 12:00 Text': 'Line = 07:30 text / 12:00 text',
  'Zeile = das Zitat (nur echte)': 'Line = the quote (real ones only)',
};
